module.exports = __webpack_public_path__ + "static/media/telegram.0f1c6709.svg";